import React, { useState, Context, ReactElement, Component } from "react";

export interface namespace_info_type_new {
    limitCPU: string;
    limitMemory: string;
    requestCPU: string;
    requestMemory: string;
    totalCPU: string;
    totalConfigmap: string;
    totalDisk: string;
    totalMemory: string;
    totalPVC: string;
    totalPod: string;
    totalRootfs: string;
    totalSecret: string;
    totalService: string;
    uptime: string;
    usedCPU: string;
    usedConfigmap: string;
    usedDisk: string;
    usedMemory: string;
    usedPVC: string;
    usedPod: string;
    usedRootfs: string;
    usedSecret: string;
    usedService: string;
    usedGPU: string;
    totalGPU: string;
}

const NamespaceInfoContext: Context<[namespace_info_type_new, React.Dispatch<React.SetStateAction<namespace_info_type_new>>]> = React.createContext<[namespace_info_type_new, React.Dispatch<React.SetStateAction<namespace_info_type_new>>]>([[] as unknown as namespace_info_type_new, (_value: any) => { }]);

const NamespaceInfoProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [namespace_info, set_namespace_info]: [namespace_info_type_new, React.Dispatch<React.SetStateAction<namespace_info_type_new>>] = useState([] as unknown as namespace_info_type_new);
    return (
        <NamespaceInfoContext.Provider value={[namespace_info, set_namespace_info]}>
            {props.children}
        </NamespaceInfoContext.Provider>
    )
}

export { NamespaceInfoContext, NamespaceInfoProvider };

